export default (date, hours) => {
    const meetingStartDate = new Date(`${date} UTC`);
    const offset = new Date(new Date().getTime() + (hours * 60 * 60 * 1000));
    const distance = meetingStartDate.getTime() - offset.getTime();

    return distance <= 0;
};
